import { getProductTags } from './productFilters';
import { getCuratedCollection } from './catalogCopy';

export const COLLECTION_SLUGS = ['2a-yoyos', 'offstring-yoyos', 'string-trick-yoyos', 'yoyo-parts'];

export const belongsToCollection = (product, slug) => {
  const tags = getProductTags(product);
  const curated = getCuratedCollection(product)?.path === `/collections/${slug}`;
  const hasStyle = tags.type.length || tags.group.length;
  const part = tags.type.includes('Yo-Yo Parts');
  if (Number(product.id) === 7) return false;
  if (!hasStyle) return curated;
  if (slug === 'yoyo-parts') return part;
  if (part) return false;
  if (slug === '2a-yoyos') return tags.group.includes('2A') || tags.type.includes('Two-Hand Looping');
  if (slug === 'offstring-yoyos') return tags.group.includes('4A') || tags.type.includes('Offstring');
  if (slug === 'string-trick-yoyos') return tags.group.includes('1A') || tags.type.includes('Single-Hand String') || tags.type.includes('Two-Hand String');
  return false;
};
